export default function WooCheckout() {
	let checkInterval;
	let radioInterval;

	// Check for radios without the correct parent and if found, wrap them
	function checkRadios() {
		if (radioInterval) {
			clearInterval(radioInterval);
		}

		radioInterval = setInterval(function () {
			const radios = document.querySelectorAll(
				'.c-checkout input[type="radio"]'
			);
			const radiosWithoutCorrectParent = Array.from(radios).filter(function (
				radio
			) {
				return !radio.closest(".e-radio");
			});

			if (radiosWithoutCorrectParent.length) {
				changeRadio(radiosWithoutCorrectParent);
				checkRadios();
			}
		}, 100);
	}

	// Check for checkboxes without the correct parent and if found, wrap them
	function checkCheckboxes() {
		if (checkInterval) {
			clearInterval(checkInterval);
		}

		checkInterval = setInterval(function () {
			const checkboxes = document.querySelectorAll(
				'.c-checkout input[type="checkbox"]'
			);
			const checkboxesWithoutCorrectParent = Array.from(checkboxes).filter(
				function (checkbox) {
					return !checkbox.closest(".e-checkbox");
				}
			);

			if (checkboxesWithoutCorrectParent.length) {
				changeCheckboxes(checkboxesWithoutCorrectParent);
				checkCheckboxes();
			}
		}, 100);
	}

	// Function to wrap checkboxes with a div and append a slider and knob span
	function changeCheckboxes(checkboxes) {
		checkboxes.forEach(function (checkbox) {
			const wrapper = document.createElement("div");
			wrapper.className = "e-checkbox";
			checkbox.parentNode &&
				checkbox.parentNode.insertBefore(wrapper, checkbox);
			wrapper.appendChild(checkbox);

			setTimeout(function () {
				const slider = document.createElement("span");
				slider.className = "e-checkbox__slider";
				const knob = document.createElement("span");
				knob.className = "e-checkbox__knob";
				slider.appendChild(knob);
				wrapper.appendChild(slider);
			}, 5);
		});
	}

	// Function to wrap radio buttons with a div and append a slider and knob span
	function changeRadio(radios) {
		radios.forEach(function (radio) {
			const wrapper = document.createElement("div");
			wrapper.className = "e-radio";
			radio.parentNode && radio.parentNode.insertBefore(wrapper, radio);
			wrapper.appendChild(radio);

			setTimeout(function () {
				const slider = document.createElement("span");
				slider.className = "e-radio__slider";
				const knob = document.createElement("span");
				knob.className = "e-radio__knob";
				slider.appendChild(knob);
				wrapper.appendChild(slider);
			}, 5);
		});
	}

	// Start the initial check for radios and checkboxes
	checkRadios();
	checkCheckboxes();
}
